import ServicePageLayout from "./ServicePageLayout";

const BULLETS = [
  "Frelons asiatiques (Vespa velutina)",
  "Frelons européens (Vespa crabro)",
  "Guêpes communes et germaniques",
  "Nids en hauteur ou enterrés",
  "Combinaison et équipement spécialisé",
  "Devis express, intervention prioritaire",
];

const PROCESS = [
  { title: "Appel ou photo", desc: "Décrivez la situation, envoyez une photo par WhatsApp." },
  { title: "Diagnostic", desc: "Évaluation à distance ou sur place, devis express." },
  { title: "Destruction", desc: "Intervention sécurisée, périmètre dégagé, suivi 24h." },
];

export default function DestructionFrelonsCreuse() {
  return (
    <ServicePageLayout
      slug="destruction-frelons-creuse"
      title="Destruction de nids de frelons et guêpes en Creuse"
      seoTitle="Destruction nid frelons/guêpes Creuse (23) | K'REUSE"
      seoDescription="Destruction de nids de frelons asiatiques, frelons européens et guêpes en Creuse (23). Intervention rapide et sécurisée. 07 80 54 11 15."
      badge="Urgence anti-nuisibles · 7j/7"
      hero="Frelons asiatiques, frelons européens ou guêpes : K'REUSE EXTÉRIEUR intervient rapidement en Creuse avec un équipement professionnel pour détruire les nids en toute sécurité."
      intro="Les nids de frelons et de guêpes représentent un vrai danger pour vous, votre famille et vos animaux. Plus l'intervention est précoce, plus elle est simple et économique. Nous disposons d'une combinaison de protection intégrale, de perches télescopiques pour les nids en hauteur, et de produits homologués pour une destruction durable."
      bullets={BULLETS}
      process={PROCESS}
      ctaTitle="Un nid de frelons ou guêpes ?"
      ctaDesc="Appelez maintenant, on intervient rapidement."
      image="/img/photos/nid-frelons.webp"
      whatsappText="URGENCE — J'ai un nid de frelons / guêpes à détruire. Voici la situation :"
    />
  );
}
